export default __webpack_public_path__ + "static/media/hht1_home_img_EP4.d85aaf39.png";